export default __webpack_public_path__ + "static/media/logo2020-300x243.b6fa9c36.png";